import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { CategoryCode } from 'config-request/src/interfaces/feature-show-all';
import { useGlobalStore } from './global';
import { getRequestIns } from '../requestIns';
import { isEmpty, optionSort } from '../utils';
import { useFeatureListStore } from './feature-list';
export const useShowAllListStore = defineStore('show-all-list', {
    state() {
        return {
            data: null,
            preShowAllData: null,
            // hasDiffConfig: false,
            lastOption: {},
            order_no: '',
            conf_no: '',
            switchGeneration: false,
        };
    },
    getters: {
        /**
         * diff配置差异
         */
        hasDiffConfig() {
            console.log('---111---');
            if (this.switchGeneration)
                return true;
            if (!this.data?.category_list || !this.preShowAllData?.category_list)
                return false;
            const oldDeductionItem = this.preShowAllData.category_list.find((category) => {
                return category.code === CategoryCode.Deduction;
            });
            const deductionItem = this.data.category_list.find((category) => {
                return category.code === CategoryCode.Deduction;
            });
            return (!!this.preShowAllData &&
                (!optionSort(this.data.option_list, this.preShowAllData.option_list) ||
                    oldDeductionItem?.order_person_type !==
                        deductionItem?.order_person_type));
        },
        /**
         * 组合包入口文案
         */
        selectOptionalPackTip() {
            return this.data?.select_optional_pack_tip;
        },
        // 版本页顶部提示条
        getTopTip() {
            return this.data?.top_tip;
        },
        // 是否展示全景图标
        show3dIcon() {
            return this.data?.switch_type === 0;
        },
    },
    actions: {
        /**
         * 订单号心愿单号 重置一下 再进行赋值，避免数据污染
         */
        resetInit() {
            this.order_no = '';
            this.conf_no = '';
            this.lastOption = {};
            this.preShowAllData = null;
            this.data = null;
            this.switchGeneration = false;
        },
        cleanData() {
            this.preShowAllData = null;
        },
        setSwitchGeneration(switchGeneration = false) {
            this.switchGeneration = switchGeneration;
        },
        /**
         * 保存配置后进行同步pre
         */
        synchronizePreData() {
            this.preShowAllData = this.data;
            this.setSwitchGeneration(false);
        },
        async formatFeatureList(showAllData) {
            // 不可编辑状态的配置总览不调用配置器相关接口
            if (!showAllData || showAllData.editable === 1)
                return;
            const globalData = useGlobalStore();
            const configs = showAllData.option_list?.map((option) => {
                return {
                    featureCode: option.feature_code,
                    code: option.code,
                    selected: true,
                };
            }) ?? [];
            const model_code = {
                featureCode: 'model_code',
                code: showAllData.model_code,
                selected: true,
            };
            configs.push(model_code);
            const generation_code = {
                featureCode: 'generation_code',
                code: showAllData.generation_code,
                selected: true,
            };
            configs.push(generation_code);
            globalData.resetCurrentOpts({
                model_code: showAllData.model_code,
                generation_code: showAllData.generation_code,
            });
            if (showAllData?.new_version) {
                globalData.updateNewVersion(showAllData.new_version);
            }
            await globalData.batchUpdateConfig(configs, null, false);
            if (!this.preShowAllData) {
                this.lastOption = {
                    ...globalData.currentFlatOptions,
                };
            }
        },
        queryShowAllList(token, params = {}, needCallback = false) {
            return this.showAllList(token, params, needCallback);
        },
        /**
         * 请求配置总览
         * @param params
         */
        async showAllList(token, params = {}, needCallback = false) {
            console.log('---444--->>>>', params);
            let globalStore = useGlobalStore();
            const currentFlatOptions = globalStore.currentFlatOptions;
            // 获取当前选择的所有配置项
            const option_list = globalStore.currentOptionList.map((item) => ({
                ...item,
            }));
            let showAllParams = {};
            console.log('---测试333---', this.conf_no, this.preShowAllData);
            if (!this.preShowAllData && this.conf_no) {
                showAllParams.conf_no = this.conf_no;
                showAllParams.order_person_type =
                    currentFlatOptions.order_person_type ?? 1;
                console.log('---测试000---');
            }
            else if (!this.preShowAllData && this.order_no) {
                showAllParams.order_no = this.order_no;
            }
            else if (!this.preShowAllData && params?.unique_key) {
                console.log('---参数里存在uniquekey---');
            }
            else {
                showAllParams = {
                    option_list,
                    generation_code: currentFlatOptions.generation_code,
                    model_code: currentFlatOptions.model_code,
                    order_person_type: currentFlatOptions.order_person_type ?? 1,
                };
                console.log('---测试222---', currentFlatOptions, showAllParams);
                if (!currentFlatOptions.model_code ||
                    !currentFlatOptions.generation_code) {
                    return null;
                }
            }
            console.log('---测试111---');
            this.order_no && (showAllParams.order_no = this.order_no);
            globalStore.orderNo && (showAllParams.order_no = globalStore.orderNo);
            Object.assign(showAllParams, params);
            console.log('---555--->>>', showAllParams);
            const result = await this.showAllRequest(showAllParams, token);
            console.log('---result---', result);
            if (result?.data?.non_selectable_option_list) {
                useFeatureListStore().refreshOptionDisabledStatus(result.data.non_selectable_option_list);
            }
            if (needCallback) {
                await this.formatFeatureList(result?.data);
                if (!result || !result.data) {
                    return {
                        result: null,
                        after: async () => {
                            await this.formatFeatureList(result?.data);
                            this.data = result?.data ?? null;
                            if (!this.preShowAllData && !isEmpty(this.data))
                                // this.preShowAllData = this.data
                                this.synchronizePreData();
                        },
                    };
                }
                return {
                    result: result?.data ?? null,
                    after: async () => {
                        await this.formatFeatureList(result?.data);
                        this.data = result.data || {};
                        if (!this.preShowAllData && !isEmpty(this.data))
                            // this.preShowAllData = this.data
                            this.synchronizePreData();
                    },
                };
            }
            if (!result || !result.data)
                return null;
            await this.formatFeatureList(result.data);
            this.data = result?.data || null;
            if (!this.preShowAllData && !isEmpty(this.data))
                // this.preShowAllData = this.data
                this.synchronizePreData();
            return result?.data ?? null;
        },
        showAllRequest(showAllParams, token = '') {
            return configRequest(getRequestIns()).showAll(showAllParams, {
                token: token
                    ? {
                        header: {
                            token,
                            Authorization: `Bearer ${token}`,
                        },
                    }
                    : '',
                throwError: true,
                showToast: false,
            }
            // token
            //   ? {
            //       header: {
            //         token,
            //         Authorization: `Bearer ${token}`,
            //       },
            //     }
            //   : '',
            // {
            //   throwError: true,
            // }
            );
        },
    },
});
